module.exports = __webpack_public_path__ + "static/media/checkBox.1b0ff007.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkBox.svg
// module id = 1207
// module chunks = 3